export class Checkout{
  constructor(checkout){
    this.id = checkout.id,
    this.customer_id = checkout.customer_id,
    this.created_at = checkout.created_at,
    this.update_at = checkout.update_at,
    this.owner_id = checkout.owner_id,
    this.checkin_id = checkout.checkin_id,
    this.status = checkout.status,
    this.my_status = checkout.status == 'pending' ? 0 : 1;
    this.note = checkout.note,
    this.total_price = checkout.total_price,
    this.discount = checkout.discount,
    this.user_id = checkout.user_id,
    this.point_bonus = checkout.point_bonus,
    this.sms_sent = checkout.sms_sent
  }
}
